// @ts-nocheck
import React, { useState, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { MdOutlineArrowBackIosNew } from "react-icons/md";


const videos = [
  {
    src: "vimeo",
    vimeoId: "929781926",
    description: "Amazing Thailand",
    thumbnails: "/home/videology/thumbnails/2.png",
  },
  {
    src: "/home/videology/neon_countdown.mp4",
    description: "Music Festival",
    thumbnails: "/home/videology/thumbnails/4.png",
  },
  {
    src: "/home/videology/s2o.mp4",
    description: "S2O Bangkok Music Festival",
    thumbnails: "/home/videology/thumbnails/3.png",
  },
  {
    src: "/home/videology/j_boroski.mp4",
    description: "J.Boroski - Bangkok",
    thumbnails: "/home/videology/thumbnails/5.png",
  },
  {
    src: "/home/videology/caribana_festival.mp4",
    description: "Caribana Festival",
    thumbnails: "/home/videology/thumbnails/YB_thumbnail.png",
  },
];

function Video() {
  const [currentVideo, setCurrentVideo] = useState(null);
  const videoRef = useRef(null);

  const openVideo = (videoData) => {
    setCurrentVideo(videoData);
  };

  const closeVideo = () => {
    if (videoRef.current) {
      videoRef.current.pause();
    }
    setCurrentVideo(null);
  };

  return (
    <motion.div
      className="video-container"
      initial={{ y: "100%", opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: "-100%", opacity: 0 }}
      transition={{ duration: 0.8 }}
    >
      <Link to="/">
        <MdOutlineArrowBackIosNew /> 
      </Link>

      <div className="playlist-header">
        <h1>Videography</h1>
        <p>Event • Travel • Corporate • Creative Concepts & Styling</p>
      </div>

      <div className="video-grid">
        {videos.map((data, index) => (
          <div key={index} className="video-item">
            <img
              src={data.thumbnails}
              alt="Video Thumbnail"
              className="video-thumbnail"
              onClick={() => openVideo(data)}
            />
            <div className="video-description">
              <p>{data.description}</p>
            </div>
          </div>
        ))}
      </div>

      <AnimatePresence>
        {currentVideo && (
          <motion.div
            className="video-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <div className="video-content">
              <button className="close-btn" onClick={closeVideo}>
                ✕
              </button>
              <h2>{currentVideo.description}</h2>

              {currentVideo.src === "vimeo" ? (
                <div style={{ padding: "42.19% 0 0 0", position: "relative" }}>
                  <iframe
                    src={`https://player.vimeo.com/video/${currentVideo.vimeoId}?autoplay=1`}
                    frameBorder="0"
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowFullScreen
                    title={currentVideo.description}
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                    }}
                  ></iframe>
                </div>
              ) : (
                <video
                  key={currentVideo.src}
                  ref={videoRef}
                  src={currentVideo.src}
                  controls
                  autoPlay
                  className="overlay-video"
                />
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
}

export default Video;
